import React from "react";

const NoAccess = (props) => {
  return <div>You can't access this page.</div>;
};

export default NoAccess;
